<section id="user-details-container">
  <!-- Sub Header -->
  <app-header title="User Details"></app-header>
  <!-- User Details -->
  <div class="container">
    <section class="info-box">
      <!-- https://angular.io/docs/ts/latest/guide/template-syntax.html#!#binding-syntax -->
      @if ( (user ?? null) !== null) {
        <h1 class="info-box-heading">{{(user?.First ?? '')}} {{(user?.Middle ?? '')}} {{(user?.Last ?? '')}} ({{(user.HawkId ?? '')}})</h1>
        <div class="info-box-wrapper">
        <div class="info-box-body">
          <div class="section-container flex-column">
            <h2>Email</h2>
            <p>{{ user.Email }}</p>
          </div>
          <div class="section-container">
            <h2>
              Role(s)
<!--              @if (user && user.UserRoles.length > 0) {-->
<!--                <span class="comma-seperated">s</span>-->
<!--              }-->
            </h2>
            @if ((user ?? null) !== null) {
<!--              <mat-list class="flex-column">-->
<!--                @for (urole of (user?.UserRoles ?? []); track urole; let i = $index) {-->
<!--                  <mat-list-item class="flex-column user-role-item">-->
<!--                        {{ urole.Role.RoleName }}-->

<!--                        <button mat-raised-button (click)="removeRole(urole)">-->
<!--                          <mat-icon class="mat-icon-dark">remove</mat-icon>-->
<!--                        </button>-->
<!--                  </mat-list-item>-->
<!--                }-->
<!--              </mat-list>-->
              <ul class="roles-list">
                @for (urole of (user?.UserRoles ?? []); track urole; let i = $index) {
                  <li class="roles-grid">
                    <span class="roles-name">
                      {{ urole.Role.RoleName }}
                    </span>
                    <span></span>
                    <span>
                      <button mat-raised-button (click)="removeRole(urole)">
                        <mat-icon class="mat-icon-dark">remove</mat-icon>
                      </button>
                    </span>
                  </li>
                }
              </ul>
            }
            <div class="add-user-role flex-row">
              <div class="form-field-container new-reviewer flex-row">
                <mat-form-field class="role-select" appearance="outline">
                  <mat-select
                    class="margin-right"
                    placeholder="Please select a user role"
                    [formControl]="userRoleControl">
                    @for (role of roles; track role.Id) {
                      <mat-option [value]="role.Id">{{
                        role.RoleName
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div>
                  <button
                    type="button"
                    style="margin-left: 25px"
                    mat-raised-button
                    (click)="addRole()">
                    Add Role
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-box-btn flex-row-end">
          <button class="btn-save" mat-raised-button (click)="removeUser()">
            Remove User
          </button>
          <button mat-raised-button [routerLink]="['..']">Done</button>
        </div>
      </div>
      }
    </section>
  </div>
</section>
